import React, { useState, useEffect, useCallback } from "react";
import banner from "./bannerteste.jpg";
import styled from "styled-components";
import axios from "axios";
import { useDispatch } from "react-redux";
import {
  Col,
  Form,
  Input,
  Card,
  Row,
  Select,
  Button,
  notification,
  Switch,
  Image,
  Skeleton,
  Tooltip,
} from "antd";

import { EyeTwoTone, EyeInvisibleOutlined } from "@ant-design/icons"; // Importe os ícones corretamente

import {
  clearAccessToken,
  loginSuccess,
  setAccessToken,
  setIdUser,
} from "./Token/actions";
import jwtDecode from "jwt-decode";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useSelector } from "react-redux";
import axiosInstance from "./axiosInterceptor";

const LoginScreen = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingLogin, setIsLoadingLogin] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");


  const CancelToken = axios.CancelToken;
  let cancel;

  const storeData = async (formulario) => {
    try {
      const requestBody1 = {
        mensagem: formulario.email,
      };
      const requestBody2 = {
        mensagem: formulario.password,
      };

      const response1 = await axios.post(
        "https://cripto-api-ead63b1d2b7d.herokuapp.com/criptografiatech/crip",
        requestBody1
      );
      const response2 = await axios.post(
        "https://cripto-api-ead63b1d2b7d.herokuapp.com/criptografiatech/crip",
        requestBody2
      );

      await AsyncStorage.setItem("email", response1.data.token);
      await AsyncStorage.setItem("password", response2.data.token);
    } catch (error) { }
  };

  useEffect(() => {
    const retrieveData = async () => {
      setIsLoading(true);
      try {
        const storedEmail = await AsyncStorage.getItem("email");
        const storedPassword = await AsyncStorage.getItem("password");

        if (storedEmail !== null) {
          const requestBody1 = {
            token: storedEmail,
          };
          const response1 = await axios.post(
            "https://cripto-api-ead63b1d2b7d.herokuapp.com/criptografiatech/desc",
            requestBody1
          );
          setEmail(response1.data.mensagem);
        }

        if (storedPassword !== null) {
          const requestBody2 = {
            token: storedPassword,
          };

          const response2 = await axios.post(
            "https://cripto-api-ead63b1d2b7d.herokuapp.com/criptografiatech/desc",
            requestBody2
          );

          setPassword(response2.data.mensagem);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    retrieveData();
  }, []);

  useCallback(() => {
    const retrieveData = async () => {
      try {
        const storedEmail = await AsyncStorage.getItem("email");
        const storedPassword = await AsyncStorage.getItem("password");

        if (storedEmail !== null) {
          const requestBody1 = {
            token: storedEmail,
          };
          const response1 = await axios.post(
            "https://cripto-api-ead63b1d2b7d.herokuapp.com/criptografiatech/desc",
            requestBody1
          );

          setEmail(response1.data.mensagem);
        }

        if (storedPassword !== null) {
          const requestBody2 = {
            token: storedPassword,
          };

          const response2 = await axios.post(
            "https://cripto-api-ead63b1d2b7d.herokuapp.com/criptografiatech/desc",
            requestBody2
          );
          setPassword(response2.data.mensagem);
        }
      } catch (error) {
        setIsLoadingLogin(false);
      }
      setIsLoadingLogin(false);
    };

    retrieveData();
  }, []);

  const handleLogin = async (formulario) => {
    setIsLoadingLogin(true);

    const url = "https://auth2-tech.herokuapp.com/oauth/token";
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: "Basic cGhvdG9BcGs6cGhvdG9hcGs1NjM4NA==",
    };

    const data = new URLSearchParams();
    data.append("username", formulario.email);
    data.append("password", formulario.password);
    data.append("grant_type", "password");

    try {
      const timeout = setTimeout(() => {
        cancel("Request timed out");
      }, 25000);

      const response = await axios.post(url, data.toString(), {
        headers,
        cancelToken: new CancelToken(function executor(c) {
          cancel = c;
        }),
      });

      clearTimeout(timeout);
      /*  if(!jwtDecode(response.data.access_token).authorities.includes('800522846F017E9FF413885608DB3110')){
          window.alert('Acesso negado!');
           setIsLoadingLogin(false);
           return;
          }*/



      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + response.data.access_token,
        },
      };

      // 🔹 1ª requisição: buscar terminal do usuário
      const terminalResp = await axios.get(
        `https://techfood-api.herokuapp.com/v1/terminal-comercial/usuario/${jwtDecode(response.data.access_token).usuario_id}`,
        options
      );
      console.log(terminalResp);

      if (!terminalResp.data) {
        alert("Terminal não configurado, entre em contato com o suporte!");
        setIsLoadingLogin(false);
        return;
      }


      const grupos = await axios.get(
        `https://auth2-tech.herokuapp.com/v1/usuarios/${jwtDecode(response.data.access_token).usuario_id
        }/grupos`,
        options
      );
      console.log(grupos.data?._embedded?.grupos);
      const temGrupoSecretaria = grupos.data?._embedded?.grupos?.some(
        (grupo) => String(grupo.id) === '3'
      );

      if (!temGrupoSecretaria) {
        window.alert('Você não tem acesso a este portal. Em caso de dúvida, entre em contato com o suporte.');
        setIsLoadingLogin(false);
        return;
      }


      dispatch(setAccessToken(response.data.access_token));
      window.localStorage.setItem("accessToken", response.data.access_token);
      dispatch(setIdUser(jwtDecode(response.data.access_token).usuario_id));
      window.localStorage.setItem(
        "idUser",
        jwtDecode(response.data.access_token).usuario_id
      );

      window.localStorage.setItem(
        'operador',
        jwtDecode(response.data.access_token).nome_completo,
      );


      /* if (response.data.access_token) {
         console.log('Antes da chamada TPAMB');
         console.log('Antes da chamada TPAMB');
         console.log('Antes da chamada TPAMB');
         console.log('Antes da chamada TPAMB');
         console.log(jwtDecode(response.data.access_token).usuario_id);
         console.log(response.data.access_token);
         const tpAmbStorage =  window.localStorage.getItem('tpAmb');
         console.log('tpAmbStorage');
         console.log(tpAmbStorage);
         if (tpAmbStorage == '1' || tpAmbStorage == '2') {
         } else {
           const options = {
             headers: {
               Accept: 'application/json',
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + response.data.access_token,
             },
           };
 
           const loja = await axios.get(
             `https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${
               jwtDecode(response.data.access_token).usuario_id
             }`,
             options,
           );
           console.log('após buscar a loja');
           console.log(loja);
 
           const tpAmb = loja.data.tp_amb;
           console.log('tpAmb');
           console.log('tpAmb');
           console.log(tpAmb);
           window.localStorage.setItem('tpAmb', tpAmb);
         }
       }*/



      if (response.data.access_token) {
        setIsLoadingLogin(false);
        dispatch(loginSuccess());
        storeData(formulario);
        window.location.reload();
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        alert("A requisição foi cancelada:" + error.message);

        setIsLoadingLogin(false);
      }
      if (error.response.status === 400) {
        alert("Login ou senha incorretos!!");
        console.error("Ocorreu um erro durante a requisição:", error);
        setIsLoadingLogin(false);
      } else {
        alert("Ocorreu um erro durante a requisição:" + error);
        console.error("Ocorreu um erro durante a requisição:", error);
        setIsLoadingLogin(false);
      }
    }
  };
  return (
    <Container>
      <Overlay />

      <PainelLogin>
        <AreaMarca>
          <BadgeSistema>
            PDV • Fiscal • Gestão
          </BadgeSistema>

          <TituloMarca>
            TechsPDV
          </TituloMarca>

          <DescricaoMarca>
            Controle suas vendas, documentos fiscais e operações
            em um único lugar.
          </DescricaoMarca>

          <ListaBeneficios>
            <Beneficio>
              <span>✓</span>
              Emissão de NF-e, NFC-e e NFS-e
            </Beneficio>

            <Beneficio>
              <span>✓</span>
              Gestão de vendas e pagamentos
            </Beneficio>

            <Beneficio>
              <span>✓</span>
              Operação rápida e segura
            </Beneficio>
          </ListaBeneficios>
        </AreaMarca>

        <CardLogin>
          <CabecalhoLogin>
            <IconeLogin>
              🖥️
            </IconeLogin>

            <div>
              <TituloLogin>
                Acessar o sistema
              </TituloLogin>

              <SubtituloLogin>
                Informe suas credenciais para continuar.
              </SubtituloLogin>
            </div>
          </CabecalhoLogin>

          {isLoading ? (
            <AreaLoading>
              <Skeleton active />
            </AreaLoading>
          ) : (
            <Form
              autoComplete="off"
              layout="vertical"
              onFinish={async (novoTerminal) => {
                handleLogin(novoTerminal);
              }}
            >
              <Form.Item
                label="Usuário"
                name="email"
                initialValue={email}
                rules={[
                  {
                    required: true,
                    message: "Informe o usuário",
                  },
                ]}
              >
                <Input
                  size="large"
                  placeholder="Digite seu usuário"
                  prefix={
                    <span style={{ color: "#9ca3af" }}>
                      👤
                    </span>
                  }
                  style={estiloInputLogin}
                />
              </Form.Item>

              <Form.Item
                label="Senha"
                name="password"
                initialValue={password}
                rules={[
                  {
                    required: true,
                    message: "Informe a senha",
                  },
                ]}
              >
                <Input.Password
                  size="large"
                  placeholder="Digite sua senha"
                  prefix={
                    <span style={{ color: "#9ca3af" }}>
                      🔒
                    </span>
                  }
                  iconRender={(visible) =>
                    visible
                      ? <EyeTwoTone />
                      : <EyeInvisibleOutlined />
                  }
                  style={estiloInputLogin}
                />
              </Form.Item>

              <LinhaSenha>
                <a
                  href="https://auth2-tech.herokuapp.com/esqueci_senha"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Esqueci minha senha
                </a>
              </LinhaSenha>

              <Button
                type="primary"
                htmlType="submit"
                loading={isLoadingLogin}
                block
                size="large"
                style={estiloBotaoEntrar}
              >
                Entrar
              </Button>

              <Button
                type="default"
                block
                size="large"
                style={estiloBotaoVoltar}
                onClick={() => {
                  window.location.href =
                    "https://techspdv.com.br/";
                }}
              >
                ← Voltar ao site
              </Button>

              <RodapeLogin>
                <span>TechsPDV</span>
                <span>V1.0.9</span>
              </RodapeLogin>
            </Form>
          )}
        </CardLogin>
      </PainelLogin>
    </Container>
  );
};
const estiloInputLogin = {
  minHeight: "48px",
  borderRadius: "10px",
  border: "1px solid #d1d5db",
  boxShadow: "none",
};

const estiloBotaoEntrar = {
  minHeight: "48px",
  marginTop: "6px",
  border: "1px solid #000000",
  borderRadius: "10px",
  background:
    "linear-gradient(135deg, #27272a, #000000)",
  color: "#ffffff",
  fontSize: "15px",
  fontWeight: "800",
  boxShadow:
    "0 6px 14px rgba(0, 0, 0, 0.22)",
};

const estiloBotaoVoltar = {
  minHeight: "46px",
  marginTop: "10px",
  border: "1px solid #d1d5db",
  borderRadius: "10px",
  background: "#ffffff",
  color: "#374151",
  fontSize: "14px",
  fontWeight: "700",
};
const Container = styled.div`
  position: relative;

  width: 100%;
  min-height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 28px;

  overflow: auto;

  background-image: url(${banner});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  box-sizing: border-box;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;

  background:
    linear-gradient(
      135deg,
      rgba(15, 23, 42, 0.84),
      rgba(17, 24, 39, 0.62)
    );

  backdrop-filter: blur(2px);
`;

const PainelLogin = styled.div`
  position: relative;
  z-index: 1;

  width: 100%;
  max-width: 980px;
  min-height: 560px;

  display: grid;
  grid-template-columns:
    minmax(0, 1.15fr)
    minmax(360px, 0.85fr);

  overflow: hidden;

  background: rgba(255, 255, 255, 0.97);
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 22px;

  box-shadow:
    0 25px 60px rgba(0, 0, 0, 0.28);

  @media (max-width: 820px) {
    max-width: 470px;
    grid-template-columns: 1fr;
  }
`;

const AreaMarca = styled.div`
  position: relative;

  padding: 48px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  overflow: hidden;

  background:
    linear-gradient(
      145deg,
      rgba(17, 24, 39, 0.98),
      rgba(49, 46, 129, 0.92)
    );

  color: #ffffff;

  &::after {
    content: "";

    position: absolute;
    right: -100px;
    bottom: -130px;

    width: 340px;
    height: 340px;

    border-radius: 50%;

    background:
      rgba(255, 255, 255, 0.07);
  }

  @media (max-width: 820px) {
    display: none;
  }
`;

const BadgeSistema = styled.span`
  width: fit-content;

  margin-bottom: 20px;
  padding: 7px 12px;

  border: 1px solid
    rgba(255, 255, 255, 0.22);
  border-radius: 999px;

  background:
    rgba(255, 255, 255, 0.10);

  color:
    rgba(255, 255, 255, 0.92);

  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.8px;
  text-transform: uppercase;
`;

const TituloMarca = styled.h1`
  margin: 0;

  color: #ffffff;

  font-size: 44px;
  font-weight: 900;
  letter-spacing: -1.5px;
`;

const DescricaoMarca = styled.p`
  max-width: 430px;

  margin: 15px 0 0;

  color:
    rgba(255, 255, 255, 0.80);

  font-size: 16px;
  line-height: 1.6;
`;

const ListaBeneficios = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  margin-top: 34px;
`;

const Beneficio = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  color:
    rgba(255, 255, 255, 0.88);

  font-size: 13px;
  font-weight: 600;

  span {
    width: 24px;
    height: 24px;

    display: flex;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;

    border-radius: 50%;

    background:
      rgba(255, 255, 255, 0.14);

    color: #ffffff;
    font-size: 12px;
  }
`;

const CardLogin = styled.div`
  padding: 42px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  background: #ffffff;

  @media (max-width: 520px) {
    padding: 28px 22px;
  }
`;

const CabecalhoLogin = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;

  padding-bottom: 20px;
  margin-bottom: 22px;

  border-bottom: 1px solid #e5e7eb;
`;

const IconeLogin = styled.div`
  width: 48px;
  height: 48px;

  display: flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;

  border-radius: 13px;

  background: #eef2ff;

  font-size: 24px;
`;

const TituloLogin = styled.h2`
  margin: 0;

  color: #111827;

  font-size: 22px;
  font-weight: 850;
`;

const SubtituloLogin = styled.span`
  display: block;
  margin-top: 3px;

  color: #6b7280;

  font-size: 13px;
`;

const LinhaSenha = styled.div`
  display: flex;
  justify-content: flex-end;

  margin-top: -8px;
  margin-bottom: 18px;

  a {
    color: #4f46e5;

    font-size: 12px;
    font-weight: 700;

    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

const AreaLoading = styled.div`
  min-height: 280px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const RodapeLogin = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding-top: 18px;
  margin-top: 20px;

  border-top: 1px solid #e5e7eb;

  color: #9ca3af;

  font-size: 11px;
  font-weight: 700;
`;

export default LoginScreen;
